module.exports = __webpack_public_path__ + "img/header-back-reserve.c66bc96c.png";